// Reports getters
export default {
  get_reports_list: (state) => state.adminReports,
  get_reports_count: (state) => state.count,
  get_report: (state) => state.report,
};
